// extracted by mini-css-extract-plugin
export var bigImageSlider = "style-mod--big-image-slider--39e73";
export var buttonTitle = "style-mod--button-title--92245";
export var imagesContainer = "style-mod--images-container--b6f90";
export var leftImage = "style-mod--left-image--2cc1e";
export var mainTitle = "style-mod--main-title--4b2b2";
export var prodSubtitle = "style-mod--prod-subtitle--555d2";
export var prodTitle = "style-mod--prod-title--df711";
export var productImg = "style-mod--product-img--b8a26";
export var rightImages = "style-mod--right-images--144f4";
export var singleImgItem = "style-mod--single-img-item--8ca12";
export var smallImages = "style-mod--small-images--449dc";
export var svgArrow = "style-mod--svg-arrow--74155";